import { useEffect, useState } from 'react';

export function useLastResolvedValue<T>(
  value: T,
  options?: { defaultValue?: T },
) {
  const [resolvedValue, setResolvedValue] = useState<T>(
    options?.defaultValue ?? value,
  );

  useEffect(() => {
    if (value) {
      setResolvedValue(value);
    }
  }, [value]);

  return value ?? resolvedValue;
}
